import { render, staticRenderFns } from "./ModalMedicineService.vue?vue&type=template&id=a820e484"
import script from "./ModalMedicineService.vue?vue&type=script&lang=js"
export * from "./ModalMedicineService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports